/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { enterpriseColors } from '../../../style/colors';

const BADGE_SIZE = 30;

const styles = StyleSheet.create({
  badgeWrapper: {
    height: BADGE_SIZE,
    width: BADGE_SIZE,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'default',
    ':focus-visible': {
      outlineColor: enterpriseColors.PRIMARY_400,
      backgroundColor: enterpriseColors.NEUTRAL_100,
    },
  },
  primary: {
    border: `1px solid ${enterpriseColors.NEUTRAL_300}`,
    backgroundColor: enterpriseColors.NEUTRAL_300,
    color: enterpriseColors.WHITE,
    fontWeight: 500,
    fontSize: 'sm',
  },
});

export namespace UserBadge {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {
    label: string;
  }
}

export const UserBadge: React.FC<UserBadge.Props> = ({ label }) => {
  return (
    <div className={css(styles.badgeWrapper, styles.primary)} data-it="UserBadge">
      <div>{label}</div>
    </div>
  );
};
